import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class ImageUpload extends Component {
  static propTypes = {
    onChangeImg: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      file: '',
      imagePreviewUrl: ''
    }
    this._handleImageChange = this._handleImageChange.bind(this)
  }

  _handleImageChange(e) {
    e.preventDefault()

    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = () => {
      this.setState(
        {
          file: file,
          imagePreviewUrl: reader.result
        },
        this.props.onChangeImg({
          file: file,
          imagePreviewUrl: reader.result
        })
      )
    }

    reader.readAsDataURL(file)
  }

  render() {
    let { imagePreviewUrl } = this.state
    let $imagePreview = null
    if (imagePreviewUrl) {
      $imagePreview = <img src={imagePreviewUrl} />
    }

    return (
      <div className="contentNotes">
        <form onSubmit={this._handleSubmit}>
          <input type="file" onChange={this._handleImageChange} />
        </form>
        {$imagePreview}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/ImageLoader/ImageLoader.js